export default __webpack_public_path__ + "static/media/teodor-drobota-1920.a4e8a8ba.jpg";